<div class="main-content table-page table-page--compact incidencias-board-page">
  <div class="container-fluid">
    <section class="table-page__card">
      <div class="incidencias-qa-page__toolbar-anchor">
        <div class="table-page__toolbar table-page__toolbar--filters">
          <div class="table-page__filters-grid incidencias-qa-page__filters-grid">
            <div class="table-page__filter table-page__filter--wide">


              <mat-form-field appearance="outline" class="table-page__field">
                <mat-label>Proyecto</mat-label>
                <mat-select [(ngModel)]="selectProyecto" placeholder="Proyectos"
                  (selectionChange)="capturarProyecto($event.value)" id="proyecto" name="proyecto">
                  <mat-option>
                    <ngx-mat-select-search [formControl]="formProyecto" [placeholderLabel]="'Proyecto'"
                      [noEntriesFoundLabel]="'No se encontró información'">
                    </ngx-mat-select-search>
                  </mat-option>
                  <mat-option *ngFor="let proyectos of filterProyecto | async" [value]="proyectos.id">
                    {{ proyectos.nombre }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>

            <div class="table-page__filter table-page__filter--medium" *ngIf="mostrarEtapa">
              <mat-form-field appearance="outline" class="table-page__field">
                <mat-label>Etapa</mat-label>
                <mat-select [(ngModel)]="selectEtapa" (selectionChange)="capturaretapa($event.value)" id="etapa"
                  name="etapa">
                  <mat-option>
                    <ngx-mat-select-search [formControl]="formEtapa" [placeholderLabel]="'Etapa'"
                      [noEntriesFoundLabel]="'No se encontro inforamción'">
                    </ngx-mat-select-search>
                  </mat-option>
                  <mat-option *ngFor="let etapas of filterEtapa | async" [value]="etapas.id">
                    {{ etapas.nombre }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
          </div>

          <div class="table-page__toolbar-actions incidencias-qa-page__toolbar-actions" *ngIf="activaproyecto">
            <label class="table-page__page-size incidencias-qa-page__page-size">
              <span>Registros</span>
              <select [ngModel]="regPag" (ngModelChange)="onItemsPerPageChange($event)">
                <option *ngFor="let option of pageSizeOptions" [ngValue]="option">{{ option }}</option>
              </select>
            </label>

            <button type="button" mat-raised-button
              class="btn table-page__icon-btn table-page__icon-btn--secondary incidencias-qa-page__toolbar-btn"
              (click)="altaincidencia()">
              <i class="material-icons">add</i>
              <span>Agregar</span>
            </button>

            <button type="button" mat-raised-button
              class="btn table-page__icon-btn table-page__icon-btn--secondary incidencias-qa-page__toolbar-btn"
              (click)="reporte()">
              <i class="material-icons">summarize</i>
              <span>Reporte</span>
            </button>

            <button type="button" mat-raised-button
              class="btn table-page__icon-btn table-page__icon-btn--secondary incidencias-qa-page__toolbar-btn"
              #filtersButton (click)="activafiltros($event)">
              <i class="material-icons">search</i>
              <span>{{ texto }}</span>
              <strong class="incidencias-qa-page__toolbar-badge" *ngIf="getActiveFiltersCount() > 0">
                {{ getActiveFiltersCount() }}
              </strong>
            </button>

            <div class="incidencias-qa-page__toolbar-summary">
              <span>Total</span>
              <strong>{{ boardTotalItems }}</strong>
            </div>
          </div>

          <div class="incidencias-qa-page__toolbar-summary incidencias-qa-page__toolbar-summary--placeholder"
            *ngIf="!activaproyecto">
            <span>Total visible</span>
            <strong>0</strong>
          </div>
        </div>

        <div class="incidencias-qa-page__filters-popover" #filtersPopover *ngIf="filtersPopupOpen"
          [class.is-open]="filtersPopupOpen">
          <div class="incidencias-qa-page__filters-dialog">
            <div class="incidencias-qa-page__filters-dialog-header">
              <div>
                <h3>Filtros</h3>
                <p>Los campos visibles filtran solo cuando tienen un valor seleccionado.</p>
              </div>
            </div>

            <div class="incidencias-qa-page__filters-panel">
              <div
                class="table-page__filters-grid incidencias-qa-page__filters-grid incidencias-qa-page__filters-grid--advanced">
                <div class="table-page__filter">
                  <mat-form-field appearance="outline" class="table-page__field">
                    <mat-label>Prioridad</mat-label>
                    <mat-select [formControl]="prioridades" multiple (selectionChange)="applyFiltersIncidencias()">
                      <mat-select-trigger>
                        {{ prioridades.value ? prioridades.value[0] : '' }}
                        <span *ngIf="prioridades.value?.length > 1" class="example-additional-selection">
                          (+{{ prioridades.value.length - 1 }} {{ prioridades.value?.length === 2 ? 'otro' : 'otros' }})
                        </span>
                      </mat-select-trigger>
                      <mat-option *ngFor="let prioridad of listaprioridades" [value]="prioridad.nombre">
                        {{ prioridad.nombre }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>

                <div class="table-page__filter">
                  <mat-form-field appearance="outline" class="table-page__field">
                    <mat-label>Tipo</mat-label>
                    <mat-select [formControl]="tipos" multiple (selectionChange)="applyFiltersIncidencias()">
                      <mat-select-trigger>
                        {{ tipos.value ? tipos.value[0] : '' }}
                        <span *ngIf="tipos.value?.length > 1" class="example-additional-selection">
                          (+{{ tipos.value.length - 1 }} {{ tipos.value?.length === 2 ? 'otro' : 'otros' }})
                        </span>
                      </mat-select-trigger>
                      <mat-option *ngFor="let tipo of listaTipo" [value]="tipo.tipo">
                        {{ tipo.tipo }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>

                <div class="table-page__filter">
                  <mat-form-field appearance="outline" class="table-page__field">
                    <mat-label>Nombre de Incidencia</mat-label>
                    <input matInput aria-label="Nombre de Incidencia" type="text" name="nombre" [(ngModel)]="titulo" id="nombre" maxlength="30"
                      (keyup)="applyFiltersIncidencias()" />
                  </mat-form-field>
                </div>

                <div class="table-page__filter">
                  <mat-form-field appearance="outline" class="table-page__field">
                    <mat-label>Estatus</mat-label>
                    <mat-select [formControl]="verestatus" multiple (selectionChange)="applyFiltersIncidencias()">
                      <mat-select-trigger>
                        {{ verestatus.value ? verestatus.value[0] : '' }}
                        <span *ngIf="verestatus.value?.length > 1" class="example-additional-selection">
                          (+{{ verestatus.value.length - 1 }} {{ verestatus.value?.length === 2 ? 'otro' : 'otros' }})
                        </span>
                      </mat-select-trigger>
                      <mat-option *ngFor="let topping of listaEstatus" [value]="topping">
                        {{ topping }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>

                <div class="table-page__filter">
                  <mat-form-field appearance="outline" class="table-page__field">
                    <mat-label>Fecha Inicio</mat-label>
                    <input matInput aria-label="Fecha Inicio" [matDatepicker]="factura_Fecha_inicio" [(ngModel)]="fec_ini"
                      (dateChange)="applyFiltersIncidencias()" [max]="maxDate" />
                    <mat-datepicker-toggle matSuffix [for]="factura_Fecha_inicio"></mat-datepicker-toggle>
                    <mat-datepicker #factura_Fecha_inicio></mat-datepicker>
                  </mat-form-field>
                </div>

                <div class="table-page__filter">
                  <mat-form-field appearance="outline" class="table-page__field">
                    <mat-label>Fecha Final</mat-label>
                    <input matInput aria-label="Fecha Final" [matDatepicker]="factura_Fecha_fin" [(ngModel)]="fec_fin"
                      (dateChange)="applyFiltersIncidencias()" [max]="maxDate" />
                    <mat-datepicker-toggle matSuffix [for]="factura_Fecha_fin"></mat-datepicker-toggle>
                    <mat-datepicker #factura_Fecha_fin></mat-datepicker>
                  </mat-form-field>
                </div>

                <div class="table-page__filter">
                  <mat-form-field appearance="outline" class="table-page__field">
                    <mat-label>No. Incidencia</mat-label>
                    <input matInput aria-label="No. Incidencia" [min]="1" type="number" name="numero" [(ngModel)]="numeroInci" id="numero"
                      (keyup)="applyFiltersIncidencias()" soloNumeroEntero />
                  </mat-form-field>
                </div>

                <div class="table-page__filter">
                  <mat-form-field appearance="outline" class="table-page__field">
                    <mat-label>Empleado</mat-label>
                    <mat-select [(ngModel)]="idUsuario" (selectionChange)="applyFiltersIncidencias()">
                      <mat-option *ngFor="let emp of listaEmpleados" [value]="emp.usuario.id">
                        {{ emp.persona.nombreCompleto }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
              </div>
            </div>

            <div class="incidencias-qa-page__filters-dialog-actions">
              <button type="button" mat-raised-button
                class="btn table-page__icon-btn table-page__icon-btn--secondary incidencias-qa-page__toolbar-btn"
                (click)="limpiaFiltrosPopup()">
                <i class="material-icons">filter_alt_off</i>
                <span>Limpiar</span>
              </button>
              <button type="button" mat-raised-button class="btn table-page__icon-btn incidencias-qa-page__toolbar-btn"
                (click)="cerrarFiltrosPopup()">
                <i class="material-icons">done</i>
                <span>Listo</span>
              </button>
            </div>
          </div>
        </div>
      </div>

      <ng-container *ngIf="activaproyecto; else seleccionPendienteTpl">
        <div class="incidencias-qa-page__board-shell">
          <div class="incidencias-qa-page__drag-hint">
            <mat-icon>pan_tool_alt</mat-icon>
            <span>Arrastra para ver más columnas</span>
          </div>

          <div class="incidencias-qa-page__board" [class.is-loading]="loading" [class.is-dragging]="isDraggingBoard"
            #boardScroller (mousedown)="startBoardDrag($event)" (mousemove)="moveBoardDrag($event)"
            (mouseup)="stopBoardDrag()" (mouseleave)="stopBoardDrag()">
            <article class="incidencias-qa-page__column" *ngFor="let registro of listaGlobal"
              [style.--incidencia-column-color]="registro.color">
              <header class="incidencias-qa-page__column-header" [style.backgroundColor]="registro.color">
                <div class="incidencias-qa-page__column-title">
                  <span class="material-icons">{{ registro.icon }}</span>
                  <div class="incidencias-qa-page__column-title-text">
                    <strong>{{ registro.titulo }}</strong>
                    <small>{{ getConfigByStatus(registro.titulo)?.totalItems || 0 }}</small>
                  </div>
                </div>
              </header>

              <div class="incidencias-qa-page__column-pager"
                *ngIf="(getConfigByStatus(registro.titulo)?.totalItems || 0) > 0">
                <div class="table-page__pager incidencias-qa-page__pager">
                  <button type="button" class="table-page__pager-link" (click)="firstPage(registro.titulo)"
                    aria-label="Primera página" title="Primera página"
                    [disabled]="(getConfigByStatus(registro.titulo)?.currentPage || 1) <= 1">
                    «
                  </button>
                  <button type="button" class="table-page__pager-link" (click)="previousPage(registro.titulo)"
                    aria-label="Página anterior" title="Página anterior"
                    [disabled]="(getConfigByStatus(registro.titulo)?.currentPage || 1) <= 1">
                    ‹
                  </button>

                  <ng-container *ngFor="let page of getPaginationItems(getConfigByStatus(registro.titulo))">
                    <button *ngIf="isPageNumber(page); else ellipsisTpl" type="button" class="table-page__pager-page"
                      [class.is-current]="page === (getConfigByStatus(registro.titulo)?.currentPage || 1)"
                      (click)="pageChanged(page, registro.titulo)">
                      {{ page }}
                    </button>
                  </ng-container>

                  <ng-template #ellipsisTpl>
                    <span class="table-page__pager-ellipsis">...</span>
                  </ng-template>

                  <button type="button" class="table-page__pager-link" (click)="nextPage(registro.titulo)"
                    aria-label="Página siguiente" title="Página siguiente"
                    [disabled]="(getConfigByStatus(registro.titulo)?.currentPage || 1) >= getTotalPages(getConfigByStatus(registro.titulo))">
                    ›
                  </button>
                  <button type="button" class="table-page__pager-link" (click)="lastPage(registro.titulo)"
                    aria-label="Última página" title="Última página"
                    [disabled]="(getConfigByStatus(registro.titulo)?.currentPage || 1) >= getTotalPages(getConfigByStatus(registro.titulo))">
                    »
                  </button>
                </div>
              </div>

              <div class="incidencias-qa-page__column-body">
                <ng-container *ngIf="getIncidenciasByStatus(registro.titulo).length > 0; else emptyStatusTpl">
                  <app-card-inc-qa *ngFor="let row of getIncidenciasByStatus(registro.titulo)" [inc]="row"
                    [proyecto]="proy" [color]="registro.color">
                  </app-card-inc-qa>
                </ng-container>

                <ng-template #emptyStatusTpl>
                  <div class="table-page__empty-state incidencias-qa-page__empty-column">
                    <mat-icon>inbox</mat-icon>
                    <p>Sin incidencias en este estatus.</p>
                  </div>
                </ng-template>
              </div>
            </article>
          </div>
        </div>
      </ng-container>

      <ng-template #seleccionPendienteTpl>
        <div class="table-page__empty-state incidencias-qa-page__empty-selection">
          <mat-icon>dashboard_customize</mat-icon>
          <p>Seleccione un proyecto y una etapa para cargar el tablero de incidencias QA.</p>
        </div>
      </ng-template>
    </section>
  </div>
</div>